import { render, staticRenderFns } from "./DietRecord.vue?vue&type=template&id=595ff3aa&scoped=true"
import script from "./DietRecord.vue?vue&type=script&lang=js"
export * from "./DietRecord.vue?vue&type=script&lang=js"
import style0 from "./DietRecord.vue?vue&type=style&index=0&id=595ff3aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595ff3aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('595ff3aa')) {
      api.createRecord('595ff3aa', component.options)
    } else {
      api.reload('595ff3aa', component.options)
    }
    module.hot.accept("./DietRecord.vue?vue&type=template&id=595ff3aa&scoped=true", function () {
      api.rerender('595ff3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/DietRecord.vue"
export default component.exports